var _defs, _rect, _rect2, _text, _line, _rect3, _text2, _line2, _rect4, _text3, _line3, _rect5, _text4, _line4, _path, _ellipse, _text5, _text6, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioSafewolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#2c2416"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8b6f47"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "hatch",
    width: 14,
    height: 14,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    stroke: "#8b6f47",
    strokeWidth: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#ece3d2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 105,
    width: 230,
    height: 90,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 161,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 34,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "internal")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 150,
    x2: 430,
    y2: 300,
    stroke: "#2c2416",
    strokeWidth: 3,
    markerEnd: "url(#ah)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 255,
    width: 230,
    height: 90,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 311,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 34,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "external")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 430,
    y2: 300,
    stroke: "#2c2416",
    strokeWidth: 3,
    markerEnd: "url(#ah)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 405,
    width: 230,
    height: 90,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 461,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 34,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "modules")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 450,
    x2: 430,
    y2: 300,
    stroke: "#2c2416",
    strokeWidth: 3,
    markerEnd: "url(#ah)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 200,
    width: 280,
    height: 200,
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 318,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 64,
    fill: "#2c2416",
    textAnchor: "middle"
  }, "MISP")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 300,
    x2: 810,
    y2: 300,
    stroke: "#2c2416",
    strokeWidth: 3,
    markerEnd: "url(#ah)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825 205 V395 A125 34 0 0 0 1075 395 V205",
    fill: "#fdfcfa",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 950,
    cy: 205,
    rx: 125,
    ry: 34,
    fill: "#e0d7c8",
    stroke: "#2c2416",
    strokeWidth: 3
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 315,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 58,
    fill: "#8b6f47",
    textAnchor: "middle"
  }, "1M+")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 357,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 30,
    fill: "#6b5d4f",
    textAnchor: "middle"
  }, "attributes")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 485,
    fontFamily: "'Times New Roman', Times, Georgia, serif",
    fontSize: 34,
    fill: "#6b5d4f",
    textAnchor: "middle"
  }, "MySQL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioSafewolf);
export default __webpack_public_path__ + "static/media/portfolio-safewolf.2487a461e049dc2448bcec1ce267b1da.svg";
export { ForwardRef as ReactComponent };